import { FcShape } from '@dtx-company/flowcode-generator-types/src'
import { FlowcodeShape } from './ShapeSelector.types'
import { GenericButton } from '@dtx-company/shared-components/src/components/atoms/Button/index'
import { Icon } from '@dtx-company/shared-components/src/components/atoms/Icon/index'
import { StyledLi, StyledUl } from '@app/code/src/components/landing-page/styles'
import { shapeOptions } from './ShapeSelector.constants'
import React from 'react'
import events from '@dtx-company/inter-app/src/event-tracking/events/flowcode'

export interface ShapeSelectorProps {
  handleSelectShape: (shape: FlowcodeShape) => void
  selectedShape?: FcShape
  customEvent?: (label: string) => void
}

export const ShapeSelector: React.FC<ShapeSelectorProps> = ({
  handleSelectShape,
  selectedShape,
  customEvent,
  ...rest
}) => {
  return (
    <StyledUl
      data-testid="flowcode-shape-selector"
      role="radiogroup"
      justifyContent="flex-start"
      {...rest}
    >
      {shapeOptions.map((s, i) => {
        const isSelected = s.shape === selectedShape
        const borderColor = isSelected ? 'primary.flowBlue' : 'secondary.border'
        return (
          <StyledLi key={`shape-button-${i}`} role="radio" aria-checked={isSelected}>
            <GenericButton
              type="button"
              data-heap-id={`ShapeSelector${i}_Button`}
              onClick={() => {
                handleSelectShape(s)
                customEvent
                  ? customEvent(s.label)
                  : events.Flowcode_Homepage_Clicked_ShapeOption(s.label)
              }}
              borderRadius="50%"
              width="48px"
              height="48px"
              m="4px"
              data-testid={`shape-selector-${s.label}-button`}
              border={`${isSelected ? '3px' : '1px'} solid`}
              borderColor={borderColor}
            >
              <Icon src={s.icon} alt={s.label} width="30px" height="30px" />
            </GenericButton>
          </StyledLi>
        )
      })}
    </StyledUl>
  )
}
